import { queryOptions } from '@tanstack/react-query'
import { apiGet } from './client'

/**
 * Settings -> Change Log, calea noua.
 *
 * Perechea veche, din `application/controllers/settings/Change_log.php`:
 *
 *   index -> GET /settings/change_log
 *
 * Calea NU poarta `/api/v2`: il pune `apiGet`.
 *
 * UN SINGUR CAP, fiindca ecranul e o singura lista: filele (All, Portal, API,
 * ...) sunt acelasi jurnal filtrat, iar cifra de pe fiecare se socoteste din
 * chiar randurile de dedesubt.
 *
 * DOAR CITIRE. Jurnalul se scrie in cod, in
 * `application/Services/ChangeLog/Release.php`, in acelasi commit cu
 * schimbarea - nu de la tastatura, si nu din ecranul asta.
 */

/** O fila: "All", apoi cate un sistem din `Release::$systems`. */
export type ChangeLogTab = {
  id: string
  label: string
  count: number
  /** Versiunea care ruleaza pe sistemul asta. Gol = n-a fost livrat niciodata. */
  version: string
}

/** O nota a unei livrari. */
export type ChangeLogUpdate = {
  component: string
  type: string
  details: string
}

export type ChangeLogRow = {
  /** Cheia randului: sistemul intra in ea, fiindca numarul singur nu mai e unic. */
  key: string
  version: string
  releasedAt: string
  /** Ziua ca `AAAA-LL-ZZ`, ca sa se poata compara ca sir cu `<input type="date">`. */
  day: string
  author: string
  summary: string
  era: string
  components: string[]
  types: string[]
  /** Randuri de cod miscate. Zero inseamna "nu stim", nu "nimic". */
  lines: number
  notes: number
  /** Tot randul, cu litere mici, pentru cautare. */
  search: string
  isCurrent: boolean
  updates: ChangeLogUpdate[]
}

/** Capul de sectiune dintre ere, si numele erei de pe filtru. */
export type ChangeLogDivider = {
  name: string
  title: string
  note: string
}

export type ChangeLogEffortRow = {
  who: string
  ships: number
  recent: number
  /** Cat de lunga e bara, in procente din cel mai mare. */
  share: number
}

export type ChangeLogPage = {
  pageTitle: string
  moduleUrl: string
  current: string
  /** Omul care se uita: intra in cheia de localStorage `od-cl-seen-{uid}`. */
  viewer: number
  tabs: ChangeLogTab[]
  eras: Record<string, number>
  dividers: Record<string, ChangeLogDivider>
  filters: {
    authors: string[]
    types: string[]
    eras: string[]
  }
  effort: {
    rows: ChangeLogEffortRow[]
    total: number
  }
  rows: ChangeLogRow[]
  /**
   * `$settings` din macheta: cu unelte (rotita, `/settings/change_log`) sau
   * fara (subsol, `/change_log` - orice om logat, randurile nu se desfac).
   */
  settings: boolean
}

/**
 * Cele doua usi ale jurnalului, ca in portal: `settings/Change_log::index`
 * (drept `settings.change_log.read`) si `Change_log::index` (oricine e logat).
 */
export function changeLogQuery(settings = true) {
  return queryOptions({
    queryKey: ['settings', 'change-log', settings],
    queryFn: () => apiGet<ChangeLogPage>(settings ? '/settings/change_log' : '/change_log'),
  })
}
